import { Component, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { TabPageComponent } from '../tab-page/tab-page.component';

@Component({
  selector: 'crowdctrl-list-tab-page',
  standalone: true,
  imports: [TabPageComponent],
  styles: [
    `
      :host {
        display: block;
        height: 100%;
        min-height: 0;
      }
    `,
  ],
  template: `
    <crowdctrl-tab-page
      [pageTitle]="pageTitle"
      [defaultHref]="defaultHref"
      [backButtonIcon]="backButtonIcon"
      [showRefresh]="showRefresh"
      [loadFn]="loadFn"
      [refreshFn]="refreshFn"
      [contentScrollY]="contentScrollY"
      [reloadDataOnEachViewActivation]="reloadDataOnEachViewActivation"
      [toolbarColor]="toolbarColor"
      [progressBarColor]="progressBarColor"
      contentClass="ion-padding-bottom crowdctrl-list-wrapper-content"
    >
      <ng-content select="[toolbarButtons],[toolbarbuttons]"></ng-content>
      <ng-content select="[headerContent]"></ng-content>
      <ng-content select="ion-footer"></ng-content>
      <ng-content></ng-content>
    </crowdctrl-tab-page>
  `,
})
export class ListTabPageComponent {
  @ViewChild(TabPageComponent) private inner?: TabPageComponent;
  @Input() pageTitle = '';
  @Input() defaultHref: string | null = null;
  @Input() backButtonIcon?: string;
  @Input() showRefresh = false;
  @Input() loadFn?: () => Observable<unknown>;
  @Input() refreshFn?: () => Observable<unknown>;
  @Input() contentScrollY = true;
  @Input() reloadDataOnEachViewActivation = false;
  @Input() toolbarColor?: string;
  @Input() progressBarColor = 'medium';

  onRefresh(force = false): void {
    this.inner?.onRefresh(force);
  }
}
